import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

import {Observable} from 'rxjs/Observable';

/*
  Generated class for the ConsumerPointsHandlerProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class ConsumerPointsHandlerProvider {
	url: any;
	token: any;

	observers: any = [];
	subscription: any;
	availablePoints: any;

	constructor(
		public http: Http,
		public globals: Globals,
		public storage: Storage,
      	public httpHelper: HttpHelper,
	) {
		this.subscription = Observable.create(observer => {
		  this.observers.push(observer);
		});
	}

	getPointsByUser(cb){	
		this.url = this.globals.dataUrl + 'consumerPoint';

		this.storage.get('loginData').then((loginData) => {
		  this.token = loginData.access_token

		  this.http.get(
		    this.url,
		    this.httpHelper.configOptionsWithToken(loginData.access_token)
		  )
		  .map(res => res.json())
		  .subscribe(res => {
		  		this.availablePoints = res.Data;

  				this.propagatePoints();

  				if(cb) cb();
		  });   
		})
	}

	propagatePoints(){
  		if(this.observers){
  			for (var i = this.observers.length - 1; i >= 0; i--) {
  				this.observers[i].next(this.availablePoints);
  			}
  		}		
	}
}



// WEBPACK FOOTER //
// ./src/providers/consumer-points-handler.ts